import {Modal} from '@mui/material';
import styles from './CommonDialog.module.css';
import {CloseModalBtn} from '../../../../../../common-lib/src/components';
import {DialogMobile} from '../../../../../CreateBot/CreateBotMobile/TextAreaDialog/TextAreaDialog';
import {useContext} from 'react';
import {AppContext} from '../../../../../../App';

type Props = {
	title: React.ReactNode;
	onClose: () => void;
};

export const CommonDialog = ({
	title,
	onClose,
	children,
}: React.PropsWithChildren<Props>) => {
	const {isMobile} = useContext(AppContext);

	if (isMobile) {
		return (
			<DialogMobile
				title={title}
				openned
				onClose={onClose}
				className={styles.dialogMobile}
			>
				{children}
			</DialogMobile>
		);
	}

	return (
		<Modal open={true} onClose={onClose}>
			<div className={styles.modal}>
				<div className={styles.modalContainer}>
					<h2 className={styles.title}>{title}</h2>
					{children}
				</div>
				<CloseModalBtn onClose={onClose} />
			</div>
		</Modal>
	);
};
